import { DefaultState } from '@src/redux/types'

import {
  ICONFERENCE,
  ICONFERENCE_ALL,
  ICONFERENCE_ALL_FILTER,
  ICONFERENCE_ARTICLE,
  ICONFERENCE_ARTICLE_ALL,
  ICONFERENCE_ARTICLE_LIST,
  ICONFERENCE_ARTICLE_PROOF,
  ICONFERENCE_ARTICLE_STEP,
  ICONFERENCE_CATEGORY_ALL,
  ICONFERENCE_CREATE,
  ICONFERENCE_MAGAZINE_ARTICLE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [ICONFERENCE]: DefaultState<`${typeof API.ICONFERENCE}{id}`, 'get'>
  [ICONFERENCE_ARTICLE]: DefaultState<`${typeof API.ICONFERENCE_ARTICLE}{id}`, 'get'>
  [ICONFERENCE_ARTICLE_LIST]: DefaultState<`${typeof API.ICONFERENCE_ARTICLE_LIST}`, 'get'>
  [ICONFERENCE_CREATE]: DefaultState<`${typeof API.ICONFERENCE}`, 'post'>
  [ICONFERENCE_ARTICLE_STEP]: DefaultState<`${typeof API.ICONFERENCE_ARTICLE_STEP}`, 'post'>
  [ICONFERENCE_ARTICLE_PROOF]: DefaultState<`${typeof API.ICONFERENCE_ARTICLE_PROOF}`, 'post'>
  [ICONFERENCE_ALL]: DefaultState<`${typeof API.ICONFERENCE_ALL}`, 'get'>
  [ICONFERENCE_ALL_FILTER]: DefaultState<`${typeof API.ICONFERENCE_ALL_FILTER}`, 'get'>
  [ICONFERENCE_ARTICLE_ALL]: DefaultState<`${typeof API.ICONFERENCE_ARTICLE_ALL}`, 'get'>
  [ICONFERENCE_MAGAZINE_ARTICLE]: DefaultState<`${typeof API.ICONFERENCE_MAGAZINE_ARTICLE}`, 'get'>
  [ICONFERENCE_CATEGORY_ALL]: DefaultState<`${typeof API.ICONFERENCE_CATEGORY_ALL}`, 'get'>
} = () => ({
  [ICONFERENCE]: defaultState(),
  [ICONFERENCE_ARTICLE]: defaultState(),
  [ICONFERENCE_ARTICLE_LIST]: defaultState(),
  [ICONFERENCE_CREATE]: defaultState(),
  [ICONFERENCE_ARTICLE_STEP]: defaultState(),
  [ICONFERENCE_ARTICLE_PROOF]: defaultState(),
  [ICONFERENCE_ALL]: defaultState(),
  [ICONFERENCE_ALL_FILTER]: defaultState(),
  [ICONFERENCE_ARTICLE_ALL]: defaultState(),
  [ICONFERENCE_MAGAZINE_ARTICLE]: defaultState(),
  [ICONFERENCE_CATEGORY_ALL]: defaultState(),
})
